import { signIn, signOut, useSession } from 'next-auth/react';

export const useAuth = () => {
  const { data: session } = useSession();

  const logOut = () => {
    signOut({
      redirectTo: '/auth/signin',
    });
  };

  return { session, logOut, signIn };
};
